export default __webpack_public_path__ + "static/media/available-goodreads.5984d87c.svg";